exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-scrollbar::-webkit-scrollbar{width:15px!important}", ""]);

// exports
